export enum UnitOfTime {
  Minute = "minute",
  Hour = "hour",
  Day = "day",
  Week = "week",
  Month = "month",
  Year = "year",
  Forever = "forever",
}
export interface TimeZone {
  label: string;
  timeZone: string;
}

export interface TimePeriod {
  unitOfTime: UnitOfTime;
  amountOfTime: number;
}

export interface RateLimit extends TimePeriod {
  rate: number;
}

export type UnixTimestampMS = number;
